import { useEffect, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** 言語を切り替えたとき、各画面の t() を読み直す */
export function LanguageRefresh({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const [, setTick] = useState(0);

  useEffect(() => {
    const onChange = () => setTick((n) => n + 1);
    i18n.on('languageChanged', onChange);
    return () => {
      i18n.off('languageChanged', onChange);
    };
  }, [i18n]);

  return children;
}
